import { AbstractControl } from "@angular/forms";

export function NonNegativeNumberValidator(control: AbstractControl): { [key: string]: any } | null {
   if (control.value) {
      const numberValue = +control.value;
      return numberValue < 0 ? { NonNegativeNumber: true } : null;
   } else {
      return null;
   }
}
